import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormInputComponent } from './form-input/form-input.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { TextareaComponent } from './textarea/textarea.component';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { DropDownComponent } from './drop-down/drop-down.component';
import { SwitchComponent } from './switch/switch.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DocumentUploadComponent } from './document-upload/document-upload.component';
import { FormTextComponent } from './form-text/form-text.component';
import { FormMobileNoComponent } from './form-mobile-no/form-mobile-no.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    FormInputComponent,
    DatepickerComponent,
    TextareaComponent,
    RadioButtonComponent,
    DropDownComponent,
    SwitchComponent,
    CheckboxComponent,
    DocumentUploadComponent,
    FormTextComponent,
    FormMobileNoComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    FormInputComponent,
    DatepickerComponent,
    TextareaComponent,
    RadioButtonComponent,
    DropDownComponent,
    SwitchComponent,
    CheckboxComponent,
    DocumentUploadComponent,
    FormTextComponent,
    FormMobileNoComponent,
  ],
})
export class FormElementModule {}
